import Vue from 'vue'
import '@moderlab/moderlibrary/dist/moderlibrary.css'
import Moderlibrary from '@moderlab/moderlibrary'
Vue.use(Moderlibrary)
